import { create } from "zustand";
import type { OzonStoreItem, StoreStats } from "./ozon-stores-types";
import * as api from "./ozon-stores-api";

interface OzonStoresState {
  stores: OzonStoreItem[];
  total: number;
  stats: StoreStats | null;
  query: string;
  syncStatus: string;
  page: number;
  limit: number;
  loading: boolean;
  fetchStores: () => Promise<void>;
  setQuery: (q: string) => void;
  setSyncStatus: (s: string) => void;
  setPage: (p: number) => void;
  setLimit: (l: number) => void;
}

let debounceTimer: ReturnType<typeof setTimeout>;

export const useOzonStoresStore = create<OzonStoresState>((set, get) => ({
  stores: [],
  total: 0,
  stats: null,
  query: "",
  syncStatus: "",
  page: 1,
  limit: 25,
  loading: false,

  fetchStores: async () => {
    const { query, syncStatus, page, limit } = get();
    set({ loading: true });
    try {
      const res = await api.getOzonStores({
        query: query || undefined,
        sync_status: syncStatus || undefined,
        page,
        limit,
      });
      set({
        stores: res.stores ?? [],
        total: res.total,
        stats: res.stats ?? null,
        loading: false,
      });
    } catch {
      set({ loading: false });
    }
  },

  setQuery: (query) => {
    set({ query, page: 1 });
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => get().fetchStores(), 300);
  },

  setSyncStatus: (syncStatus) => {
    set({ syncStatus, page: 1 });
    get().fetchStores();
  },

  setPage: (page) => {
    set({ page });
    get().fetchStores();
  },

  setLimit: (limit) => {
    set({ limit, page: 1 });
    get().fetchStores();
  },
}));
